<template>
  <div>
    <!-- <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:800px;overflow:hidden;' : 'padding-bottom:70px'"> -->
      <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:800px;overflow:hidden;' : ''">
      <PageValidate ref="basicInfoObserver"  :productCatsRef="['btnAddCat']" :MediaListRef="['productImageUploader']">
        <template v-slot:PageBody>
          <div class="CenterCard mb-3">
            <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_Basic_BasicInformation')">
            </BasicPageTop>
            <div style="row-gap:1rem;">
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('Lbl_ProductName') }} <span class="text-danger">*</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <textbox ControlId="nameEng" vid="nameEng" @blur="setValueToAssistant" :title="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductName_PlaceOtherEn')"
                    v-model="form.ExhibitNameE" CharLimit="CheckEnglishChar" :maxLength="300"
                    :mandatory="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductName_PlaceOtherEn') + $t('lbl_IsRequire')" />
                  <ProductFieldApprovalResults usage-type="ExhibitNameE" />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <textbox ControlId="nameSimp" vid="nameSimp" @blur="setValueToAssistant" :title="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductName_PlaceOtherCn')"
                    v-model="form.ExhibitNameT" :maxLength="300"
                    :mandatory="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductName_PlaceOtherCn') + $t('lbl_IsRequire')" />
                  <ProductFieldApprovalResults usage-type="ExhibitNameS" />
                </div>
              </div>

              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    <TipsAndPrivewDilog :id="'OtherProductName_Tips'"
                      :Title="$t('lbl_EMPBE_ProductInfo_BasicInfo_OtherProductName_Tips')">
                      <template v-slot:Text>
                        {{ $t('lbl_EMPBE_ProductInfo_BasicInfo_OtherProductName') }}
                      </template>
                    </TipsAndPrivewDilog>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2">
                  <OtherProductName :value="form.Keywords" :nums="10" :supplierId="null" :ProductId="form.ProductId" />
                </div>
              </div>

              <div class="row pt-2">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    <TipsAndPrivewDilog :id="'WhichProductCategory_Tips'"
                      :Title="$t('lbl_EMPBE_ProductInfo_BasicInfo_WhichProductCategory_Tips')">
                      <template v-slot:Text>
                        {{ $t('lbl_EMPBE_ProductInfo_BasicInfo_WhichProductCategory') }} <span class="maxTip">{{$t('lbl_EMPBE_Upto',{0:1})}}</span><span class="text-danger">*
                        </span>
                      </template>
                    </TipsAndPrivewDilog>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                   <div v-if="!form.TempExhibitCat||form.TempExhibitCat.length==0" >
                    <b-button id="btnAddCat" v-model="form.TempExhibitCat" ref="btnAddCat" :selectedvalue="form.TempExhibitCat.length" class="btn btn-outline-primary p-l-15 d-flex align-items-center" variant="outline-primary"
                     @click="openCategoryModal"  v-bind:t_label="'lbl_EMPBE_ProductInfo_Catalog_AddButtom'">
                    <feather type="plus-circle"> </feather>
                      &nbsp; {{$t('lbl_EMPBE_AddCategory')}}
                   </b-button >
                   <div id="btnAddCat_require" style="display: none; color: #dc3545; padding-left: 6px; padding-top: 2px;">
                    <span v-if="form.TempExhibitCat&&form.TempExhibitCat.length==0"> {{ $t("Lbl_CatName")+ $t("lbl_IsRequire") }}</span>
                     <span v-if="form.TempExhibitCat&&form.TempExhibitCat.length>1"> {{ $t("lbl_maximumchoices").replace('#count#','1')}}</span>
                   </div>
                   </div> 
                   <span v-else v-for="item, index in productCatTextList" :key="index">  
                      <div class="selectedCat" style="">
                      <div class="selectedCatText" style="">{{item.text}}</div>
                      <div class="delectSelectedIcon" @click="handleDelete(item)">
                        <i class="el-icon-close" aria-hidden="true" style=" "></i>
                      </div>
                      </div> 
                    </span> 
                </div>
       
              </div>

              <div class="row ">
                <div class="col-12 mb-2 Input_Label" style="margin-top: 25px !important;">
                  <div class="Input_Label_Left">
                    <TipsAndPrivewDilog :id="'_WhichApplicationIndustries_Tips'"
                      :Title="$t('lbl_EMPBE_ProductInfo_BasicInfo_WhichApplicationIndustries_Tips')">
                      <template v-slot:Text>
                        {{ $t('lbl_EMPBE_ProductInfo_BasicInfo_WhichApplicationIndustries') }}<span class="maxTip">{{$t('lbl_EMPBE_Upto',{0:5})}}</span> <span
                          class="text-danger">* </span>
                      </template>
                    </TipsAndPrivewDilog>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <!-- <multiselection  id="proIndustryIds" v-model="form.productIndustry"
                    :placeholder="$t('lbl_EMPBE_ProductInfo_BasicInfo_WhichApplicationIndustries_PlaceOther')"
                    label="name" :MaxLength="5" :options="SelectOptions.IndustriesOptions" :multiple="true"
                    :mandatory="$t('lbl_ApplicationIndustries') + $t('lbl_IsRequire')" /> -->
 
                     <multiselection id="proIndustryIds" name="productIndustry" 
                     :placeholder="$t('lbl_EMPBE_ProductInfo_PleaseSelectMore1',{ nums: 5 })"
                     :title="$t('lbl_EMPBE_ProductInfo_BasicInfo_WhichApplicationIndustries_PlaceOther')"
                      v-model="form.productIndustry" label="name" track-by="code" :mandatory="$t('lbl_ApplicationIndustries') + $t('lbl_IsRequire')" 
                      :options="mstIndustriesOptionsWithCompCatStatus" :MaxLength="5" closeonselect="false"
                      :multiple="true" :taggable="false"   style="margin-bottom: 0px !important;display: inline-block;"  >
                    </multiselection>          
                     
                 
                      <!-- <div style="margin-top: 8px; position: relative;margin-bottom: 0px !important" class="theme-form form-group" >
                        <div class="lblAddCatTip" @click="toggleAdditionalIndustry" :class="form.productIndustry1.length>=5?'disabledAddCat':''"> 
                        <i :class="['fa', AdditionalAppExpanded &&form.productIndustry1.length<5? 'fa-chevron-up' : 'fa-chevron-down', 'cat-arrow']"></i>
                        If above no industries suit  for the product, add it here
                      </div>
                      <div v-show="AdditionalAppExpanded&&form.productIndustry1.length<5" style="padding-left: 20px;">
                        <div class="lblAddCat" style="">Additional display industries </div> 
                        <multiselection id="proIndustryIds_AdditionalApp" name="productIndustry2" :placeholder="$t('lbl_EMPBE_PleaseSelect')"
                          v-model="form.productIndustry2" label="name" track-by="code" :multiple="true"
                          :options="mstIndustriesOptionsWithDisabled" :MaxLength="maxIndustry2Length" :close-on-select="true" 
                          @select="selected_industry2" style="margin-bottom: 0px !important;display: inline-block;">
                        </multiselection>
                      </div>  
                  </div> -->
                  <!-- <div class="d-block invalid-feedback" style="margin-top: 0.5rem;" v-if="(dirty||form.productId>0)&&productIndustriesRules&&productIndustriesRules.required==true"> 
                    {{$t('lbl_ApplicationIndustries') + $t('lbl_IsRequire')}} 
                  </div>
                  <div class="d-block invalid-feedback" style="margin-top: 0.5rem;" v-if="(dirty||form.productId>0)&&productIndustriesRules&&productIndustriesRules.max"> 
                    {{$t('lbl_ApplicationIndustries') + $t('lbl_EMPBE_Upto',{0:5})}} 
                  </div> -->
                </div>

              </div>
              <div class="row">
                <div class="col-12 mb-2 " style="margin-top: 25px !important;">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_ProductInfo_BasicInfo_ProductPhotos') }}
                    ({{ GetImgNums }}/{{ mediaLimit }})<span class="text-danger"> * </span>
                    <span
                      v-if="!isAdminApprovalMediaMode"
                      class="lblPhotoEdit"
                      @click="()=>{ $refs.productImageUploader.openEditModalWithMediaId(form.productImageArray?.[0]?.id); }"
                    >
                      <img :src="cdnURL_Product+'Edit.svg'" class="textlengthdrop-img"/> 
                       {{ $t("lbl_EMPBE_Edit") }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2">
                  <div class="mb-2"
                    v-html="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductPhotos_P').replace('{MaxQuota}', mediaLimit)">
                  </div>
                  <MediaApprovalGallery
                    v-if="shouldShowMediaApprovalGallery(form.productImageArray)"
                    :MediaArray="form.productImageArray"
                    mode="admin"
                    media-type="image"
                    :is-show-cover="true"
                    gallery-item-style="height: 120px; width: 120px;"
                    grid-template-columns="repeat(5, 1fr)"
                    :title="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductPhotos')"
                    :approval-content-results="getMediaApprovalResults('ExhibitPhoto')"
                    :approval-content-result-drafts="getMediaApprovalDraftMap('ExhibitPhoto', form.productImageArray)"
                    :rejection-templates="mediaApprovalRejectionTemplates"
                    :rejection-actor="mediaApprovalRejectionActor"
                    @approval-draft-change="onMediaApprovalDraftChange('ExhibitPhoto', $event)"
                  />
                  <template v-else>
                    <mediaUploader
                      :isShowCover="true"
                      :isDisabled="isApprovalMediaReadOnly"
                      :MediaArray="form.productImageArray"
                      :limit="mediaLimit"
                      :maxSize="5"
                      aspectRatioStr="1:1"
                      galleryItemStyle="height: 120px; width: 120px;"
                      gridTemplateColumns="repeat(5, 1fr)"
                      mediaType="image"
                      :requirementMessage="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductPhotos_specification')"
                      ref="productImageUploader"
                      :isRequired="true"
                      :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                      fileUsageType="ExhibitPhoto"
                      filePathEndpoint="Image"
                      :reject-records="getMediaRejectRecords('ExhibitPhoto', form.productImageArray, 'image')"
                      @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'ExhibitPhoto')"
                    />
                    <MediaRejectBanner :records="getMediaRejectRecords('ExhibitPhoto', form.productImageArray, 'image')" />
                  </template>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col-12 mb-2 Input_Label_Left">
                  {{ $t('lbl_EMPBE_ProductInfo_BasicInfo_ProductVideo') }} ({{ form.videoArr.length }}/{{ videoLimit }})

                  <span
                    v-if="!isAdminApprovalMediaMode"
                    class="lblPhotoEdit"
                    @click="()=>{ $refs.productVideoUploader.openEditModalWithMediaId(form.videoArr?.[0]?.id); }"
                  >
                      <img :src="cdnURL_Product+'Edit.svg'" class="textlengthdrop-img"/> 
                       {{ $t("lbl_EMPBE_Edit") }}
                   </span>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2">
                  <div class="mb-2"
                    v-html="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductVideo_p').replace('{MaxQuota}', videoLimit)">
                  </div>
                   <div class="d-flex gap-1">
                  <div class="imgGrid-5">
                    <MediaApprovalGallery
                      v-if="shouldShowMediaApprovalGallery(form.videoArr)"
                      :MediaArray="form.videoArr"
                      mode="admin"
                      media-type="video"
                      :is-show-cover="true"
                      gallery-item-style="height: 107px; width: 128px;"
                      grid-template-columns="repeat(5, 1fr)"
                      :title="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductVideo')"
                      :approval-content-results="getMediaApprovalResults('ExhibitVideo')"
                      :approval-content-result-drafts="getMediaApprovalDraftMap('ExhibitVideo', form.videoArr)"
                      :rejection-templates="mediaApprovalRejectionTemplates"
                      :rejection-actor="mediaApprovalRejectionActor"
                      @approval-draft-change="onMediaApprovalDraftChange('ExhibitVideo', $event)"
                    />
                    <mediaUploader
                      v-else
                      :isShowCover="true"
                      :isDisabled="isApprovalMediaReadOnly"
                      :MediaArray="form.videoArr"
                      :limit="videoLimit"
                      aspectRatioStr="16:9"
                      galleryItemStyle="height: 107px; width: 128px;"
                      gridTemplateColumns="repeat(5, 1fr)"
                      mediaType="video"
                      :maxSize="100"
                      ref="productVideoUploader"
                      fileUsageType="ExhibitVideo"
                      filePathEndpoint="Video"
                      fileThumbnailUsageType="ExhibitVideo_Cover"
                      fileThumbnailPathEndpoint="VideoCapture"
                      :reject-records="getMediaRejectRecords('ExhibitVideo', form.videoArr, 'video')"
                      @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'ExhibitVideo')"
                      :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Video')"
                      :requirementMessage="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductVideo_specification')"
                    />
                  </div>
                  </div>
                  <MediaRejectBanner
                    v-if="!isAdminApprovalMediaMode"
                    :records="getMediaRejectRecords('ExhibitVideo', form.videoArr, 'video')"
                  />
                </div>
              </div>

              <div class="row pt-2">
                <div class="col-12 mb-2 Input_Label_Left">
                  {{ $t('lbl_EMPBE_ProductInfo_BasicInfo_CompanyShortVideo') }} ({{ form.shortVideoArr.length }}/{{
                    mediaLimit }})
                  <span class="NewsTips">{{ $t("lbl_EMPBE_News") }}</span>

                  <span
                    v-if="!isAdminApprovalMediaMode"
                    class="lblPhotoEdit"
                    @click="()=>{ $refs.productShortVideoUploader.openEditModalWithMediaId(form.shortVideoArr?.[0]?.id); }"
                  >
                      <img :src="cdnURL_Product+'Edit.svg'" class="textlengthdrop-img"/> 
                  {{ $t("lbl_EMPBE_Edit") }}
                   </span>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2">
                  <div class="mb-2"
                    v-html="$t('lbl_EMPBE_ProductInfo_BasicInfo_CompanyShortVideo_P').replace('{MaxQuota}', mediaLimit)">
                  </div>
                    <div class="d-flex gap-1">
                   <div class="imgGrid-5">
                    <MediaApprovalGallery
                      v-if="shouldShowMediaApprovalGallery(form.shortVideoArr)"
                      :MediaArray="form.shortVideoArr"
                      mode="admin"
                      media-type="video"
                      :is-show-cover="true"
                      gallery-item-style="height: 185px; width: 104px;"
                      grid-template-columns="repeat(5, 1fr)"
                      :title="$t('lbl_EMPBE_ProductInfo_BasicInfo_CompanyShortVideo')"
                      :approval-content-results="getMediaApprovalResults('ExhibitVideo_Short')"
                      :approval-content-result-drafts="getMediaApprovalDraftMap('ExhibitVideo_Short', form.shortVideoArr)"
                      :rejection-templates="mediaApprovalRejectionTemplates"
                      :rejection-actor="mediaApprovalRejectionActor"
                      @approval-draft-change="onMediaApprovalDraftChange('ExhibitVideo_Short', $event)"
                    />
                    <mediaUploader
                      v-else
                      :isShowCover="true"
                      :isDisabled="isApprovalMediaReadOnly"
                      :MediaArray="form.shortVideoArr"
                      :limit="mediaLimit"
                      aspectRatioStr="9:16"
                      galleryItemStyle="height: 185px; width: 104px;"
                      gridTemplateColumns="repeat(5, 1fr)"
                      mediaType="video"
                      :maxSize="100"
                      :maxDuration="60"
                      :isShowVideoPreviewBackground="true"
                      ref="productShortVideoUploader"
                      fileUsageType="ExhibitVideo_Short"
                      filePathEndpoint="Video"
                      fileThumbnailUsageType="ExhibitVideo_Short_Cover"
                      fileThumbnailPathEndpoint="VideoCapture"
                      :reject-records="getMediaRejectRecords('ExhibitVideo_Short', form.shortVideoArr, 'video')"
                      @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'ExhibitVideo_Short')"
                      :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Short_Video')"
                      :requirementMessage="$t('lbl_EMPBE_ProductInfo_BasicInfo_CompanyShortVideo_specification')"
                    />
                  </div>
                  </div>
                  <MediaRejectBanner
                    v-if="!isAdminApprovalMediaMode"
                    :records="getMediaRejectRecords('ExhibitVideo_Short', form.shortVideoArr, 'video')"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="CenterCard">
            <BasicPageTop :Name="$t('lbl_EMPBE_ProductInfo_BasicInfo_AdditionalInformation')">
            </BasicPageTop>
            <div>
              <div class="row">
                <div class="col-12">
                  <div class="Input_Label_Left mb-2">
                    {{ $t('lbl_EMPBE_ProductInfo_BasicInfo_ModelNumberOfTheProduct') }}
                  </div>
                  <div>
                    <textbox id="ModelNum" :placeholder="$t('lbl_EMPBE_ProductInfo_BasicInfo_ModelNumberOfTheProduct_placeOther')"
                      v-model="form.ModelNum" />
                    <ProductFieldApprovalResults usage-type="ModelNum" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="Input_Label_Left mb-2">
                    <span id="lblproductCapacityTitle">{{ productCapacity }}</span>
                  </div>
                </div>
              </div>
              <div class="flex-container">
                <div class="flex-item">
                  <textbox vid="AbilityNumber" :placeholder="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductionCapacity_PlaceOther')"
                    :type="'number'" v-model="form.AbilityNumber" />
                </div>
                <div class="flex-item">
                  <selection id="AbilityUnit" :placeholder="$t('lbl_EMPBE_Unit')" label="name" :options="options_SupplyUnit"
                    v-model="form.AbilityUnit">
                  </selection>
                </div>
                <div class="flex-item" v-if="form.AbilityUnit == 99">
                  <textbox :placeholder="$t('lbl_EMPBE_Unit')" v-model="form.AbilityUnitOther" />
                </div>
                <div class="flex-symbol" >
                  /
                </div>
                <div class="flex-item">
                  <selection  id="AbilityPeriod" :placeholder="$t('lbl_EMPBE_ProductInfo_BasicInfo_Time')" label="name"
                    :options="options_SupplyTime" v-model="form.AbilityPeriod">
                  </selection>
                </div>
              </div>
              <ProductFieldApprovalResults usage-type="Ability_Number" />
            </div>
          </div>
        </template>
      </PageValidate>
      
    </b-overlay>
    
    <!-- 产品类别选择模态框 -->
    <CatsOpupModal v-if="showCategoryModal" id="pro_categorySelectModal" 
    :initSelectItems="form.TempExhibitCat" :maxLength="1" :showModal.sync="showCategoryModal"
    :checkListData="SelectOptions.MstCategoriesOptions"
    :companySelectedData="SelectOptions.ProductCategoriesOptions" 
    @confirmSelected="fromChird_confirmSelectCats" 
    ></CatsOpupModal>
  </div>

</template>
<script>
import { AlertDialog } from "@/_helpers/AlertDialog";
import { getAncestorPath, getAncestorIds } from "@/_helpers/treeUtils";
import { CompanyInfoService } from "@/_services";
import { LogService } from "../../../_services/log.Service";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import BasicPageTop from "./BasicPageTop.vue"
import OtherProductName from "../Popup/OtherProductName.vue"
import { productService } from "@/_services/product.service";
import { adService } from "../../../_services";
import { fileUploadService } from "@/_services";
import CatsOpupModal from "../../../components/popup/CatalogueModal.vue"; 
import MediaUploader from "../../../components/form/upload/imgUploader/mediaUploader.vue";
import MediaRejectBanner from "../../../components/form/upload/imgUploader/mediaRejectBanner.vue";
import MediaApprovalGallery from "../../../components/form/upload/imgUploader/mediaApprovalGallery.vue";
import mediaApprovalGalleryBridge from "../../../components/form/upload/imgUploader/mediaApprovalGalleryBridge.js";
import ProductFieldApprovalResults from "../ProductFieldApprovalResults.vue";
import { getUpdateOSSUrlToDbRequest } from '@/_helpers/utility.js';
import {
  getInitImageDataObj,
  getInitVideoDataObj,
} from '@/_helpers/media-uploader-utils.js';

export default {
  mixins: [AlertDialog, mediaApprovalGalleryBridge],
  components: {
    BasicPageTop,
    OtherProductName,
    CatsOpupModal,
    MediaUploader,
    MediaRejectBanner,
    MediaApprovalGallery,
    ProductFieldApprovalResults,
  },
  props: ["supplierId", "ProductId", "SelectOptions", "permissionData", "PageLeaveType", "submitType"],
  inject: {
    productApprovalHost: { default: null },
  },

  data() {
    return {
      privateProductId: this.ProductId,
      cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/svg/CompanyInfo/",
      cdnURL_Product: "https://cdn.adsalecdn.com/EMP/Backend/svg/ProductInfo/",
      loading: false,
      IsCreated: false,
      form:
      {
        ProductId: this.$route.params.id,
        ExhibitNameT: '',
        ExhibitNameE: '',
        Keywords: [],
        TempExhibitCat: [],
        TempFromChildCat:[],
        TempExhibitIndustry: [],
        productImageArray:[],       
        videoArr: [],
        shortVideoArr: [],
        ModelNum: '',
        AbilityNumber: null,
        AbilityUnit: '',
        AbilityUnitOther: '',
        AbilityPeriod: '',
        productCats: [], 
        productIndustry: [],        
      },
      //已从父级传过�?
      // options_applicationIndustries: [],
      // options_productCats: [],
      options_SupplyUnit: [],
      options_SupplyTime: [],
      disabledDates: {
      },
      dirty: null,
      AdPageName: [
        { type: "bannerAd", name: this.$t('lbl_EMPBE_BannerAd') },
        { type: "logoAd", name: this.$t('lbl_EMPBE_LogoAd') },
        { type: "buttonAd", name: this.$t('lbl_EMPBE_ButtonAd') },
        { type: "landingAd", name: this.$t('lbl_EMPBE_LandingPageAd') },
        { type: "videoAd", name: this.$t('lbl_EMPBE_VideoAd') },
        { type: "starAd", name: this.$t('lbl_EMPBE_StarAd') },
        { type: "catListAd", name: this.$t('lbl_EMPBE_CatListAd') },
        { type: "priorityAd", name: this.$t('lbl_EMPBE_priorityAds') },
      ],
      AdCheckItems:[],
      // AdditionalCatExpanded:false,
      // AdditionalAppExpanded:false,
      showCategoryModal:false,
      originalProductCats: [], // 保存初始�?productCats，用�?removeCats 方法判断
      originalProductIndustrys:[],
      prodCats:[],
      dbUpdateCommands: {
        ExhibitPhoto: [],
        ExhibitVideo: [],
        ExhibitVideo_Short: [],
      },
      pendingUploadFiles: {
        ExhibitPhoto: [],
        ExhibitVideo: [],
        ExhibitVideo_Short: [],
      },
    };
  },
  watch: {
    // 'form.productImageArray':{
    //   handler(newVal, oldValue) {
    //   },
    //   deep: true
    // },
    'form.productIndustry': {
       async handler(newVal, oldValue) {
      // 同步内部�?
      //this.internalValue = newVal
        //console.log('productIndustry-oldValue:'+oldValue.map(item=>item).join(','))
          if(!this.IsCreated)
          {
            if(oldValue.length > newVal.length){
             var removeItemId= oldValue.find(a => !newVal.includes(a));
              let node={
                id:removeItemId
              } 
              
             var IsCheck = await  this.removeApps(node); 
             if(IsCheck==false&& oldValue.length > newVal.length){
              this.form.productIndustry = [...oldValue]
             }
            }
          }
     }
    },
    
   supplierId: {
      handler() {
        this.InitData();
      },
      deep: true
    },
    form: {
      handler() {
        if (!this.IsCreated) {
          this.dirty = true;
          this.$store.state.dirty = this.dirty;
        }
      },
      deep: true,
    },
    ProductId: {
      handler(newVal, oldVal) {
        if (newVal === oldVal || newVal === 0) return;
        return this.privateProductId = newVal;
      }
    },
  },
  computed: {
    useFormalTables() {
      return String(this.submitType || 'edit').toLowerCase() === 'approval';
    },
    reactiveProductId() {
      return this.privateProductId && this.privateProductId > 0 ? this.privateProductId : (this.$route.params.id || 0);
    },
     productCategoryRules() {
      const Catslist = this.form.TempExhibitCat || []; 
      if (Catslist.length === 0 && Catslist.length === 0) {
        return { required: true };
      }
      return null;
    },
    productIndustriesRules() {
      const primaryIndustry = this.form.productIndustry1 || [];
      const additionalIndustry = this.form.productIndustry2 || [];
      if (primaryIndustry.length === 0 && additionalIndustry.length === 0) {
        return { required: true };
      }
      if ((primaryIndustry.length + additionalIndustry.length) > 5) {
        return { max: 5 };
      }
      return null;
    },
     
    mstIndustriesOptionsWithCompCatStatus() { 
      if (!this.SelectOptions?.MstIndustriesOptions) {
        return [];
      }
         const compSelectedIds = this.SelectOptions.IndustriesOptions.map(x => x.id);
         let selectedinCompIndustryTip=this.$t('lbl_EMPBE_SelectedinCompIndustryTip')
         var newdataList=this.SelectOptions.MstIndustriesOptions.map(x => ({
                id:x.id,
                label:x.label,
                description:compSelectedIds.includes(x.id.toString()) ? `(${selectedinCompIndustryTip})` : '',
                newOrder:compSelectedIds.includes(x.id.toString())?0:x.id
                }) 
            ).sort((a, b) => {
                // 首先�?newOrder 排序
                if (a.newOrder !== b.newOrder) {
                    return parseInt(a.newOrder) - parseInt(b.newOrder);
                }
                // 如果 newOrder 相同，再�?id 排序
                return parseInt(a.id) - parseInt(b.id);
            });
                    
        if(newdataList.length === 0) {
            return [];
        }       
        return newdataList;  
    },
 
   companyId() {
    return this.supplierId;
    },
    GetImgNums() {
      return this.form.productImageArray?.length ?? 0;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    user() {
      return this.$store.state.authentication.user;
    },
    mediaLimit() {
      if (this.permissionData) {
        switch (this.permissionData["Type"]) {
          case "A+":
            return 10;
          case "A":
            return 5;
          case "B":
            return 4;
          case "C":
            return 2;
          case "Member":
            return 2;
          default:
            return 1;
        }
      }
      return 1;
    },
    videoLimit() {
      if (this.permissionData) {
        switch (this.permissionData["Type"]) {
          case "A+":
            return 5;
          case "A":
            return 5;
          case "B":
            return 4;
          case "C":
            return 2;
          case "Member":
            return 2;
          default:
            return 1;
        }
      }
      return 1;
    },
    productCapacity() { 
      let thisproduct= this.$t('lbl_EMPBE_thisProduct');
      switch (localStorage.getItem("currentLangId")) { 
        case '950':
          if (this.form.ExhibitNameT == ''||this.form.ExhibitNameT==undefined) {
            return this.$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductionCapacity').replace('{ProductName}',thisproduct)
          }
          else {
            return this.$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductionCapacity').replace('{ProductName}', this.form.ExhibitNameT)
          }
        case '936':
          if (this.form.ExhibitNameT == ''||this.form.ExhibitNameT==undefined) {
            return this.$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductionCapacity').replace('{ProductName}', thisproduct)
          }
          else {
            return this.$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductionCapacity').replace('{ProductName}', this.form.ExhibitNameT)
          }
        case '1252':
          if (this.form.ExhibitNameE == ''||this.form.ExhibitNameE==undefined) {
            return this.$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductionCapacity').replace('{ProductName}', thisproduct)
          }
          else {
            return this.$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductionCapacity').replace('{ProductName}', this.form.ExhibitNameE)
          }
      }
    },
    productCatTextList(){
      if(this.form.TempExhibitCat&&this.form.TempExhibitCat.length>0)
        {
          var catIds = this.form.TempExhibitCat.map(item=>item.subId.toString());
          if(this.SelectOptions.MstCategoriesOptions&&this.SelectOptions.MstCategoriesOptions.length){
          let textList=this.SelectOptions.MstCategoriesOptions.filter(
            item=>catIds.includes(item.id.toString())
          ).map(
            item=>({
              subId:item.id,
              text:item.text,
              mainId:item.parentId
            })
          );
           return textList;
        }
      }
        return [];
    }
  },
  mounted() {
    this.InitData();

  },
  methods: {
    GetProductCatList() {
      CompanyInfoService.GetProductCatList().then((response) => {
        this.prodCats = response.data;
      });
    },
    async GetProdUpCats(id) {
      var result2 = await getAncestorPath(this.prodCats, id);
      return result2.length > 0 ? result2 : [];
    },
    async getAncestorIds(id) {
      var result2 = await getAncestorIds(this.prodCats, id);
      return result2.length > 0 ? result2 : [];
    },

    // [BLK] Only update the stored data arrays for later manipulation
    handlerUploaderUpdateData(commands, pendingFiles, uploaderType) {
      this.dbUpdateCommands[uploaderType] = [...commands];
      this.pendingUploadFiles[uploaderType] = [...pendingFiles];
      // 图片/视频变更不走 form watch，需手动标 dirty，否则切 Tab 不会自动保存
      if (!this.IsCreated) {
        this.dirty = true;
        this.$store.state.dirty = true;
      }
    },

    async CheckHasAd(type, newVal, oldVal) {

      //获取被删的id
      var CheckIds = oldVal.filter(item => !newVal.includes(item)).map(item => item + '')
      await this.GetAdCheckItem();
      var PageTypes = this.AdCheckItems.filter(item => item.searchType == type && CheckIds.includes(item.searchId + '')).map(item => item.pageType)

      if (PageTypes.length > 0) {
        var Names = '';
        var AdNames = '';
        var Tips = '';
        AdNames = this.AdPageName.filter(item => PageTypes.includes(item.type)).map(item => item.name).join(",")
        if (type === 'app') {
          Names = this.options_applicationIndustries.filter(item => CheckIds.includes(item.id + '')).map(item => item.label).join(",")
          Tips = this.$t('lbl_EMPBE_ProductInfoCheckItems_App', { names: Names, adnames: AdNames });
        } else {
          Names = this.options_productCats.filter(item => CheckIds.includes(item.id + '')).map(item => item.label).join(",")
          Tips = this.$t('lbl_EMPBE_ProductInfoCheckItems_Cat', { names: Names, adnames: AdNames });
        }

        //提示�?
        this.showConfirm_Img(
          '',
          Tips,
          this.$t('lbl_EMPBE_Confirm'),
          "",
          "",
          "",
          50,
          50,
          "AlertDialog-Ad-SaveSucess",
          true,
          "",
          "",
          "",
          false,
          false,
          true,
          false
        )
        return true;
      } else {
        return false;
      }
    },
    async GetAdCheckItem() {
      await adService
        .GetAdCheckItem({ CompId: this.companyId, productId: this.form.ProductId })
        .then((res) => {
          if (res.isSuccessful) {
            this.AdCheckItems = res.data;
          }
        })
    },

    //多�?删除选择事件
    delSelectCats(node) {
      let TempExhibitCats = this.form.TempExhibitCat;
      let index = TempExhibitCats.findIndex(a => a.subId.toString() === node.subId.toString());
      if (index !== -1) {
        TempExhibitCats.splice(index, 1);
        //已一起删
        //var idx_temp=this.form.TempFromChildCat.findIndex(item => item.subId.toString() === node.subId.toString());
        // if (idx_temp !== -1) 
        // this.form.TempFromChildCat.splice(idx_temp, 1);
       }
      this.form.TempExhibitCat = TempExhibitCats;
    },
    fromChird_confirmSelectCats(TempFromChildCat){
      if(TempFromChildCat==0)
      {
        this.$swal({
        html: this.$t("lbl_EMPBE_PleaseSelect")+this.$t("Lbl_SelectSearchProductCat"),
        showCancelButton: false,
        confirmButtonText: text ? text : this.$t("lbl_EMPBE_Confirm")
      })
      }else{
      this.form.TempExhibitCat=TempFromChildCat;
      }
     
    } 
    , 

    async handleDelete(item){//catType 1：主要类型�?：其他类�?isTrueDelete:是否是真删除，如果是修改的时候，做假删除
      const isConfirmed = await this.removeCats(item);
        if(isConfirmed==true) 
        {
          let node={subId:item.subId}
          this.delSelectCats(node);
        }
        return isConfirmed;
    },   
    async GetAdItemList(id){
      var res = await this.GetProdUpCats(id);
      var data = this.AdCheckItems.filter(item=>item.searchType == 'cat' && res.includes(item.searchId.toString()));
      return data;
    },
    async GetAdRepeatCount(id,CheckUpId){
      // 规则：先按 level2（CheckUpId）判断；若 level2 下原本只有当前这一个，则回退按 level1 判断

      const treeForCats =
        (this.SelectOptions &&
          this.SelectOptions.ProductCategoriesOptions &&
          Array.isArray(this.SelectOptions.ProductCategoriesOptions) &&
          this.SelectOptions.ProductCategoriesOptions.length > 0)
          ? this.SelectOptions.ProductCategoriesOptions
          : this.prodCats;

      const allSelected = [
        ...(this.productCatTextList || [])
      ];
      const remainingSelected = allSelected.filter(x => String(x.subId) !== String(id));

      // 判断一个选项是否“属于某个上级Id(UpId)”
      const isUnderUpId = (x, upId) => {
        if (upId == null) return false;
        if (String(x.subId) === String(upId)) return true;
        if (String(x.mainId) === String(upId)) return true;
        const ancestors = getAncestorIds(treeForCats, x.subId);
        return !!(ancestors && ancestors.some(a => String(a) === String(upId)));
      };

      // 当前被删项的 level1（root）
      const currentAncestors = getAncestorIds(treeForCats, id); // 只取上级，不含自身
      const level1 = (currentAncestors && currentAncestors.length > 0) ? currentAncestors[0] : null;

      // level2 判断：若 level2 下原本有多个，则只有删到最后一个才返回 true
      if (CheckUpId != null) {
        const countBefore = allSelected.filter(x => isUnderUpId(x, CheckUpId)).length;
        const countAfter = remainingSelected.filter(x => isUnderUpId(x, CheckUpId)).length;

        if (countBefore > 1) {
          const result = countAfter === 0;
          return result;
        }
      } else {
        // 没有 level2，上来就回退 level1
      }

      // level1 回退：只要 level1 下还有其他项，就不是最后一个
      if (!level1) {
        return true;
      }

      const level1CountAfter = remainingSelected.filter(x => isUnderUpId(x, level1)).length;
      const result = level1CountAfter === 0;
      return result;
    },
    async removeCats(item){
       // 使用保存的初始�?originalProductCats 来判断，避免 this.form.productCats 被外部修改影�?
       const originalData =this.originalProductCats || [];
       var hasSaveIdObj = originalData.find(a=>a.subId.toString() == item.subId.toString());//已保存的id才判断移�?
       
     if(hasSaveIdObj)
        {
        var CheckId=item.subId.toString();
        var CheckUpId=item.mainId.toString();
        var chekcedList = await this.GetAdItemList(CheckId);  //this.AdCheckItems.filter(a=>a.searchType == 'cat' && CheckId==a.searchId.toString()).map(a=>a.pageType)

        if(chekcedList.length>0){
          const isLastOneUnderParent = await this.GetAdRepeatCount(CheckId,CheckUpId);
          var adNamesList = isLastOneUnderParent
            ? chekcedList.map(a => this.AdPageName.filter(b => b.type == a.pageType).map(c => c.name)).flat()
            : [];
            
          var AdNames = [...new Set(adNamesList)].join(",");
          var lbladName = this.$t('Lbl_Advertisement');
          var adNameTextTips = `<ul class='ItemUL' ><li >${lbladName}: <span style='font-weight: 400; '>${AdNames}</span> </li></ul>`;
          var lblTypeName=this.$t('lbl_EMPBE_ProductCategory'); 

        //提示框：
          return new Promise((resolve, reject) => { 
            this.ConfirmCustomHtml(
            this.$t('lbl_EMPBE_DeleteCategory_Title',{CatName:item.text}),
            this.$t('lbl_EMPBE_DeleteCategory_body',{fromType:lblTypeName,AdOrproText:adNameTextTips}),
            this.$t('lbl_EMPBE_Delete'),
            this.$t('lbl_EMPBE_ProductInfo_Delete_Cancel')
          ).then(async (res) => {
                 resolve(res.isConfirmed);
              });
          });


          } else{
            //移除
            let node={subId:item.subId}
            this.delSelectCats(node); 
           }
      }else{
        //移除
          let node={subId:item.subId}
          this.delSelectCats(node);
      }
    },
 

    removeApps(item){
       //console.log('removeApps'); 
      
       // 使用保存的初始�?originalProductCats 来判断，避免 this.form.productCats 被外部修改影�?
       const originalData =this.originalProductIndustrys||[];
      //console.log('保存�?originalProductCats:', originalData);
      var hasSaveIdObj =originalData.find(a=>a.industryId.toString() == item.id.toString());//已保存的id才判断移�?
       
    if(hasSaveIdObj)
      {
        var CheckId=hasSaveIdObj.industryId.toString();
        var PageTypes =  this.AdCheckItems.filter(a=>a.searchType == 'app' && a.searchId.toString()==CheckId).map(a=>a.pageType)
          //console.log('PageTypes'+PageTypes)
          if(PageTypes.length>0){
          //var Names = '';
          var AdNames ='';
          //var Tips = '';
          AdNames = this.AdPageName.filter(a=>PageTypes.includes(a.type)).map(a=>a.name).join(",");     
            var lbladName = this.$t('Lbl_Advertisement');

         var adNameTextTips = `<ul class='ItemUL' ><li >${lbladName}: <span style='font-weight: 400; '>${AdNames}</span> </li></ul>`;
         var lblCatName=this.SelectOptions.IndustriesOptions.find(a=>a.id.toString()==item.id.toString()).label;
         var lblTypeName=this.$t('lbl_EMPBE_ProductInfoApp'); 
          this.ConfirmCustomHtml(
          this.$t('lbl_EMPBE_DeleteCategory_Title',{CatName:lblCatName}),
          this.$t('lbl_EMPBE_DeleteCategory_body',{fromType:lblTypeName,AdOrproText:adNameTextTips}),
          this.$t('lbl_EMPBE_Delete'),
          this.$t('lbl_EMPBE_ProductInfo_Delete_Cancel')
        ).then(async (res) => {
          if (res.isConfirmed) {
            //删除productCat              
            let index = this.form.productIndustry.findIndex(a => a.toString() === item.id.toString());
            if (index !== -1) {
              this.form.productIndustry.splice(index, 1);
             } 
            return true;//删除
          }else{
            // 取消删除，清除标志位即可（值已经还原，不需要额外操作）
            this.isRemovingApp = false;
            //console.log('取消删除');
            return false;
          }
        });
         return false; 
          } else{
            return true;//删除 
           }
      }else{
        //移除
        return true;//删除 
      }
    },
    
    InitData() {
      this.GetProductCatList();
      this.GetAdCheckItem();
      this.GetData();
      this.resetFormVerify();
      setTimeout(() => {
        this.dirty = false;
        this.$store.state.dirty = this.dirty;
      }, 200);
      // let parms = {
      //   LangId: this.langid,
      //   CompanyId: this.user.empCompanyId,
      // };
      //应用行业
      // productService.GetIndustryByCompanyId(parms).then((response) => {
      //   if (response.isSuccessful) {
      //     let dataList = response.data;
      //     this.options_applicationIndustries = dataList;

      //   }
      // });
      //公司选择的产品类�?
      // productService.GetProductCatByCompanyId(parms).then((response) => {
      //   if (response.isSuccessful) {
      //     var dataList = response.data;
      //     this.options_productCats = dataList;
      //   }
      // });
      
      productService
        .GetMstKeyValueMapping({ type: "UOM", langId: this.langid })
        .then((res) => {
          if (res.isSuccessful) {
            this.options_SupplyUnit = [];

            for (let index = 0; index < res.data.length; index++) {
              var item = {
                id: res.data[index].code,
                label: res.data[index].text,
              };
              this.options_SupplyUnit.push(item);
            }
          }
        });

      productService
        .GetMstKeyValueMapping({ type: "Abilityunit", langId: this.langid })
        .then((res) => {
          if (res.isSuccessful) {
            this.options_SupplyTime = [];

            for (let index = 0; index < res.data.length; index++) {
              var item = {
                id: res.data[index].code,
                label: res.data[index].text,
              };
              this.options_SupplyTime.push(item);
            }
          }
        });
    },
    resetFilePendingUpdate() {
      for (const prop in this.dbUpdateCommands) {
        this.$set(this.dbUpdateCommands, prop, []);
      }

      for (const prop in this.pendingUploadFiles) {
        this.$set(this.pendingUploadFiles, prop, []);
      }
    },
    getInitVideoDataObjWithCoverFile(file, fileProps, coverFile) {
      const coverId = coverFile?.rid;
      const coverCdnLink = coverFile?.fileName;
      const coverOrderId = coverFile?.orderId;
      const coverUsageType = coverFile?.usageType;

      return getInitVideoDataObj(
        file,
        fileProps,
        coverFile ? coverFile : {},
        coverFile ? {
          id: coverId,
          cdnLink: coverCdnLink,
          orderId: coverOrderId,
          usageType: coverUsageType
        } : {}
      );
    },
    GetData() {
      this.loading = true;
      this.IsCreated = true;
      this.form.productImageArray = []
      this.form.videoArr = []
      this.form.shortVideoArr = []
      let param = { productId: this.reactiveProductId, useFormalTables: this.useFormalTables }
      this.resetFilePendingUpdate();
      productService.GetProductBasicInfo(param).then(res => {
        if (res.isSuccessful) {
          const data = res.data
          this.form.ProductId = data.tempCompanyExhibit?.productId
          this.form.ExhibitNameE = data.tempCompanyExhibit?.exhibitNameE
          this.form.ExhibitNameT = data.tempCompanyExhibit?.exhibitNameT
          this.form.Keywords = data.tempExhibitKeyword
          this.form.ModelNum = data.tempCompanyExhibit?.modelNum
          this.form.AbilityNumber = data.tempCompanyExhibit?.ability_Number
          this.form.AbilityUnit = data.tempCompanyExhibit?.ability_Unit
          this.form.AbilityUnitOther = data.tempCompanyExhibit?.ability_Unit_Other
          this.form.AbilityPeriod = data.tempCompanyExhibit?.ability_Period
          //this.form.productCats = data.tempExhibitCat;
          this.form.TempExhibitCat=data.tempExhibitCat;
          // 保存初始�?productCats，用�?removeCats 方法判断，避免被后续修改影响
          this.originalProductCats = Array.isArray(data.tempExhibitCat)  ? JSON.parse(JSON.stringify(data.tempExhibitCat))  : [];

             this.originalProductIndustrys= Array.isArray(data.tempExhibitIndustry) 
            ? JSON.parse(JSON.stringify(data.tempExhibitIndustry)) 
            : [];

          let tempExhibitIndustrys = data.tempExhibitIndustry;
          if (tempExhibitIndustrys.length > 0) {
          let applicationIndustries = [];
          tempExhibitIndustrys.forEach((element) => {
            applicationIndustries.push("" + element.industryId + "");
          });
          this.form.productIndustry = applicationIndustries;
          }

          let tempExhibitCats = data.tempExhibitCat;
          if (tempExhibitCats?.length > 0) {
            let productCats = [];
            tempExhibitCats.forEach((element) => {
              productCats.push("" + element.subId + "");
            });
            this.form.productCats = productCats;
          }


          // const primaryCount = (this.form.productIndustry1 || []).length;
          // this.maxIndustry1Length= Math.max(0, 5 - primaryCount);
          // const additionalCount = (this.form.productIndustry2 || []).length;
          // this.maxIndustry2Length= Math.max(0, 5 - primaryCount-additionalCount);
          // console.log('maxIndustry1Length'+this.maxIndustry1Length,this.maxIndustry2Length)
  
          let files = data.tempMediaFile;
          let newImageArray = [];
          let newVideoArr = [];
          let newShortVideoArr = [];
          
          if (files.length > 0) {
            for (const file of files) {
              if (!file.fileName) continue;
              
              const id = file.rid;
              const cdnLink = file.fileName;
              const orderId = file.orderId;
              const usageType = file.usageType;
              if (file.usageType?.toLowerCase() === "exhibitphoto".toLowerCase()) {
                newImageArray.push(getInitImageDataObj(file, { id, cdnLink, orderId, usageType }));
                continue;
              }

              if (file.usageType?.toLowerCase() === "exhibitvideo".toLowerCase()) {
                const coverFile = files.find(
                  (f) => f.usageType === "ExhibitVideo_Cover" && f.orderId == file.orderId
                );
                newVideoArr.push(this.getInitVideoDataObjWithCoverFile(file, { id, cdnLink, orderId, usageType }, coverFile));
                continue;
              }

              if (file.usageType?.toLowerCase() === "exhibitvideo_short".toLowerCase()) {
                const coverFile = files.find(
                  (f) => f.usageType === "ExhibitVideo_Short_Cover" && f.orderId == file.orderId
                );
                newShortVideoArr.push(this.getInitVideoDataObjWithCoverFile(file, { id, cdnLink, orderId, usageType }, coverFile))
                continue;
              }
            }

            // Assign the local arrays to the component data to prevent duplicates
            this.form.productImageArray = newImageArray;
            this.form.videoArr = newVideoArr;
            this.form.shortVideoArr = newShortVideoArr;
          }
        }
        setTimeout(() => {
          this.IsCreated = false;
        }, 500);
        //this.loading = false;
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      })
    },
    //重置表单验证
    resetFormVerify() {
     // if (this.$refs.basicInfoObserver) {
        this.$refs.basicInfoObserver.reset();
     // }
    },

    fileUploadHandle(isSubmit = true) {
      const pendingFiles = [...this.pendingUploadFiles.ExhibitPhoto, ...this.pendingUploadFiles.ExhibitVideo, ...this.pendingUploadFiles.ExhibitVideo_Short];
      const commands = [...this.dbUpdateCommands.ExhibitPhoto, ...this.dbUpdateCommands.ExhibitVideo, ...this.dbUpdateCommands.ExhibitVideo_Short];

      return this.$submitFormMessage.FileUploadHandleWithPopup({
        isSubmit,
        pendingFiles,
        commands,
        getFailedText: {
          "ExhibitPhoto": this.$t("lbl_EMPBE_ProductInfo_BasicInfo_ProductPhotos"),
          "ExhibitVideo": this.$t("lbl_EMPBE_ProductInfo_BasicInfo_ProductVideo"),
          "ExhibitVideo_Cover": this.$t("lbl_EMPBE_ProductInfo_BasicInfo_ProductVideo"),
          "ExhibitVideo_Short": this.$t("lbl_EMPBE_ProductInfo_BasicInfo_CompanyShortVideo"),
          "ExhibitVideo_Short_Cover": this.$t("lbl_EMPBE_ProductInfo_BasicInfo_CompanyShortVideo"),
        },
        uploadFinishCallback: (failedFilesFields) => this.$emit("uploadFinish", failedFilesFields)
      });
    },

    //整理結果提交save
    async AfterSaveResult(isSubmit) {
    //  console.log('companyId:'+this.companyId)
      let tempExhibitIndustry = []

      this.form.productIndustry.forEach((element, index) => {
        let TempExhibitIndustry = {
          ProductId: this.form.ProductId,
          IndustryId: element,
          OrderId: index + 1,
        };
        tempExhibitIndustry.push(TempExhibitIndustry);
      });

      let tempExhibitCats= this.form.TempExhibitCat.map(item =>({
                  ProductId: this.form.ProductId,
                  SubId:item.subId,
                  MainId:item.mainId,
                  OrderId:item.order
                  }));

      let data =
      {
        ProductId: this.form.ProductId,
        EmpCompanyId: this.companyId,
        ExhibitNameT: this.form.ExhibitNameT,
        ExhibitNameE: this.form.ExhibitNameE,
        Keywords: this.form.Keywords,
        productCats: tempExhibitCats,
        ProductIndustry: tempExhibitIndustry,
        //ProductIndustry: this.form.TempExhibitIndustry,
        ModelNum: this.form.ModelNum,
        AbilityNumber: this.form.AbilityNumber,
        AbilityUnit: this.form.AbilityUnit,
        AbilityUnitOther: this.form.AbilityUnitOther,
        AbilityPeriod: this.form.AbilityPeriod,
        VaildError: [], //验证失败的filed
        validationErrorLog: "", //验证的errorlog
        isSuccessful:true,
        LangId: this.langid
      };

      try {
        const res = await this.fileUploadHandle(isSubmit);

        // console.log('fileUploadHandle res: ', res);

        return {
          data: data,
          fileUploadResult: res,
        };
      } catch (error) {
        // 增强错误信息处理
        let errorMessage = '';
        if (error && error.message) {
          errorMessage = error.message;
        } else if (typeof error === 'string') {
          errorMessage = error;
        } else {
          errorMessage = '文件上传失败，请重试';
        }

        // 如果是超时或网络错误，提供更友好的提�?
        if (errorMessage.includes('timeout') || errorMessage.includes('超时')) {
          errorMessage = '文件上传超时，文件可能过大或网络较慢，请尝试压缩文件后重试';
        } else if (errorMessage.includes('Network Error') || errorMessage.includes('网络')) {
          errorMessage = '网络连接异常，请检查网络连接后重试';
        }

        data.validationErrorLog += (data.validationErrorLog ? '; ' : '') + errorMessage;
        console.error('文件上传错误详情:', error);

      }

      return {
        data: data,
        fileUploadResult: null,
      };
    },

    LogPageFormError(errorLogObj, action) {
      LogService.LogFormErrorWithObj({
        EmpCompanyId: this.companyId,
        EmpProductId: this.reactiveProductId,
        PageName: this.$route.path.split("/")[1],
        SectionName: "BasicInfo",
        Action: action,
      }, errorLogObj);
    },

    async SaveFileUrlToDB(uploadData, productId = 0, isSubmit = false) {
      try {
        const request = {
          ...uploadData,
          EmpCompanyId: this.companyId,
          EmpProductId: productId
        };

        await fileUploadService.UpdateOssUrlToDb(request);
      } catch (err) {
        this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, isSubmit ? 'Submit_SaveProductBasicInfo_UpdateOssUrlToDb' : 'Save_SaveProductBasicInfo_UpdateOssUrlToDb');
        throw err;
      }
    },

    //保存
    async Save() {
      const saveRes = await this.AfterSaveResult(false);
      const data = saveRes.data;

      // console.log("Save data", data);
      // Log Form Data
      const query = {
        FormId: this.reactiveProductId,
        Action: 'Before_Save',
        FormType: 'ProductInfo_BasicInfo',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);
      
      return new Promise((resolve, reject) => {
        productService.SaveProductBasicInfo(data).then(async (res) => {
          if (res.isSuccessful) {
            this.privateProductId = res.data;
            const newProductId = !this.$route.params.id || this.$route.params.id == 0 ? res.data : 0; // For adding new product id when reject  

            await this.SaveFileUrlToDB(getUpdateOSSUrlToDbRequest(saveRes.fileUploadResult), res.data, false).catch(err => {
              reject({
                newProductId,
                message: this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: `SaveFileUrlToDB ${err?.name || 'Error'}: ` + (err?.message || "Unexpected Error") })
              })
            });

            this.InitData();
            
            resolve({ data: res.data, state: true });
          }
          else {
            this.LogPageFormError({ res: res }, 'Save_SaveProductBasicInfo');

            if (res.msg?.includes("Upstream data expired")) {
              this.$emit("refreshCompantedFunc");
              reject({
                message: this.$t("lbl_EMPBE_Upstreamdataexpired_Prod")
              });
            } else {
              reject({
                message: this.$t("lbl_EMPBE_Save_Failed_HasErrorAndCode", { code: res.statusCode, msg: res.msg?.join(",") || "Error" })
              });
            }
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, 'Save_SaveProductBasicInfo');
          reject({
            message: this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: err.message })
          });
        })
      });
    },
    //提交
    async Submit() {
      const saveRes = await this.AfterSaveResult(true);
      const data = saveRes.data;

      const query = {
        FormId: this.reactiveProductId,
        Action: 'Before_Submit',
        FormType: 'ProductInfo_BasicInfo',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, saveRes);

      // console.log('Submit Data', data);
      return new Promise((resolve, reject) => {
        productService.SaveProductBasicInfo(data).then(async (result) => {
          if (result.isSuccessful) {
            this.privateProductId = result.data;
            const newProductId = !this.$route.params.id || this.$route.params.id == 0 ? result.data : 0; // For adding new product id when reject

            await this.SaveFileUrlToDB(getUpdateOSSUrlToDbRequest(saveRes.fileUploadResult), result.data, true).catch(err => {
              reject({
                newProductId,
                message: this.$t("lbl_EMPBE_Submit_Failed_HasError", { msg: `SaveFileUrlToDB ${err?.name || 'Error'}: ` + (err?.message || "Unexpected Error") })
              })
            });

            this.$refs.basicInfoObserver
              .validate(true)
              .then(async (res) => {
                // Log Form Data
                data.VaildError = res.fIldData;

                if (res.valid) {
                  this.InitData();
                  resolve({ data: result.data, isAllMandatoryFieldsFilled: true });
                }
                else {
                  this.GetData();
                  resolve({ data: result.data, isAllMandatoryFieldsFilled: false });
                }

              });
          } else {
            this.LogPageFormError({ result: result }, 'Submit_SaveProductBasicInfo');
            if (result.msg?.includes("Upstream data expired")) {
              this.$emit("refreshCompantedFunc");
              reject({
                message: this.$t("lbl_EMPBE_Upstreamdataexpired_Prod")
              });
            } else {
              reject({
                message: this.$t("lbl_EMPBE_Submit_Failed_HasErrorAndCode", { code: result.statusCode, msg: result.msg?.join(",") || "Error" })
              });
            }
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, 'Submit_SaveProductBasicInfo');
          reject({
            message: this.$t("lbl_EMPBE_Submit_Failed_HasError",{ msg: err.message })
          });
        });
      });
    },
     openCategoryModal(){
      //console.log('this.showCategoryModal:'+this.showCategoryModal);
      this.showCategoryModal = true;
    },
    setValueToAssistant(){ 
      //console.log('setValueToAssistant');
      let exhibitName=this.productCapacity;
      let lblNeedTofill_ModelNum=document.getElementById('needToFill_ModelNum');
      if(lblNeedTofill_ModelNum)
      {
        lblNeedTofill_ModelNum.innerHTML=exhibitName;
      }
    }
  },
};
</script>
<style>
.templateImg {
  height: 150px;
  object-fit: cover;
  object-position: top;
}

.flex-container {
  display: flex;
  max-width: 59.125rem;
  align-items: flex-start;
  gap: 0.5rem;
  align-self: stretch;
}

.flex-container .form-group {
  margin-bottom: 0rem !important;
}

.flex-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.1875rem;
  flex: 100;
}

.flex-symbol {
  display: flex;
  width: 0.5rem;
  margin-bottom: 1rem;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
}

.NewsTips {
  padding: 4px 6px;
  align-items: center;
  gap: 2px;
  border-radius: 25px;
  background: var(--Warning, #FFD02C);
  overflow: hidden;
  color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
  text-align: center;
  text-overflow: ellipsis;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  /* 18px */
  letter-spacing: -0.132px;
}
.lblPhotoEdit{
  float: right;
  font-size: 14px;
  font-weight: 600;
  color:var(--branding-color-primary-supplier-backend, #7366FF);
  cursor: pointer;
}

.maxTip{
  color: rgba(0, 0, 0, 0.40);
    font-size: 14px;
    /* font-family: Inter; */
    font-weight: 700;
    line-height: 18.20px;
    word-wrap: break-word;
}
.cat-arrow {
    font-size: 10px !important; 
    transition: transform 0.3s ease;
    padding: 3px 5px 0 3px;;
}
 </style>
 <style>
.delectSelectedIcon{
  width: 16px; height: 16px; position: relative; overflow: hidden;
  margin-top: -3px;
  cursor: pointer;
  margin-top: -5px;
}
.delectSelectedIcon i{ 
  font-size: 16px;
  color: rgba(0, 0, 0, 0.40);
  font-weight: 600;
}
.selectedCat{
  height: 100%; padding-top: 8px; 
  padding-bottom: 8px; 
  padding-left: 12px; padding-right: 8px; 
  background: rgba(115, 102, 255, 0.10); 
  border-radius: 99px; 
  justify-content: center; align-items: center; gap: 4px; 
  display: inline-flex;
  height: 32px;
  margin: 2px;
}
.selectedCatText{
text-box-trim: trim-both; 
text-box-edge: cap alphabetic; 
justify-content: center; display: flex; 
flex-direction: column; color: rgba(0, 0, 0, 0.80); 
font-size: 14px; 
/* font-family: Inter;  */
font-weight: 500; 
line-height: 14px; word-wrap: break-word
}
.topPartText{
 padding-bottom: 16px;
 color: rgba(0, 0, 0, 0.80); 
 font-size: 14px; 
 /* font-family: Inter;  */
 font-weight: 400; 
 line-height: 21px; 
 word-wrap: break-word;
}
.AdPartText
{
  width: 100%;height: 100%;padding: 16px;
  background: #FCEBED;border-radius: 8px;
  justify-content: flex-start;
  align-items: flex-start;gap: 8px;
  display: inline-flex
}
.AdText{
  flex: 1 1 0; flex-direction: column; justify-content: flex-start; 
    align-items: flex-start; gap: 4px; display: inline-flex;
}
.AdTextTitle{  
    align-self: stretch;  justify-content: center; display: flex; flex-direction: column; color: #CD1515; font-size: 
    14px; 
    /* font-family: Inter;  */
    font-weight: 400; line-height: 20px; word-wrap: break-word
}
.ItemUL{
  align-self: stretch; justify-content: center; display: flex; flex-direction: column;
  padding-left: 20px;;
}
.ItemUL li{
  color: #CD1515;font-size: 14px;
  /* font-family: Inter; */
  font-weight: 700;line-height: 25.20px;word-wrap: break-word;
         list-style: disc; 
}   
</style>